import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../../../components/CustomFormsComponents/CustomField';
import { TFunction } from 'i18next';
import { TEST_IDS } from '../testIds';

const useEmployeeQuantityFieldsConfig = ({
    t,
    employeeQuantityFormData,
    handleBlurValidation
}: {
    t: TFunction;
    employeeQuantityFormData: any;
    handleBlurValidation: any;
}) => {
    const [employeeQuantityFieldsConfig, setEmployeeQuantityFieldsConfig] = useState<FieldConfig[]>(
        []
    );

    useEffect(() => {
        const employeeQuanityFieldsConfig: FieldConfig[] = [
            {
                type: 'text',
                label: t('workersQuantityForm.inputs.ownAdministrativeWorkers') as string,
                name: 'ownAdministrativeWorkers',
                required: true,
                value: employeeQuantityFormData.ownAdministrativeWorkers,
                disabled: false,
                helperText: t('workersQuantityForm.inputs.ownAdministrativeWorkers') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                gridSpace: { xs: 12, md: 6 },
                testID: TEST_IDS.employeeQuantityFields.ownAdministrativeWorkers,
                validations: [
                    { name: 'required' },
                    { name: 'maxLength', param: 14 },
                    { name: 'minValue', param: 0 }
                ]
            },
            {
                type: 'text',
                label: t('workersQuantityForm.inputs.ownProductionWorkers') as string,
                name: 'ownProductionWorkers',
                required: true,
                value: employeeQuantityFormData.ownProductionWorkers,
                disabled: false,
                helperText: t('workersQuantityForm.inputs.ownProductionWorkers') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                gridSpace: { xs: 12, md: 6 },
                testID: TEST_IDS.employeeQuantityFields.ownProductionWorkers,
                validations: [
                    { name: 'required' },
                    { name: 'maxLength', param: 14 },
                    { name: 'minValue', param: 0 }
                ]
            },
            {
                type: 'text',
                label: t('workersQuantityForm.inputs.eventualAdministrativeWorkers') as string,
                name: 'eventualAdministrativeWorkers',
                required: true,
                value: employeeQuantityFormData.eventualAdministrativeWorkers,
                disabled: false,
                helperText: t('workersQuantityForm.inputs.eventualAdministrativeWorkers') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                gridSpace: { xs: 12, md: 6 },
                testID: TEST_IDS.employeeQuantityFields.eventualAdministrativeWorkers,
                validations: [
                    { name: 'required' },
                    { name: 'maxLength', param: 14 },
                    { name: 'minValue', param: 0 }
                ]
            },
            {
                type: 'text',
                label: t('workersQuantityForm.inputs.eventualProductionWorkers') as string,
                name: 'eventualProductionWorkers',
                required: true,
                value: employeeQuantityFormData.eventualProductionWorkers,
                disabled: false,
                helperText: t('workersQuantityForm.inputs.eventualProductionWorkers') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                gridSpace: { xs: 12, md: 6 },
                testID: TEST_IDS.employeeQuantityFields.eventualProductionWorkers,
                validations: [
                    { name: 'required' },
                    { name: 'maxLength', param: 14 },
                    { name: 'minValue', param: 0 }
                ]
            }
        ];

        setEmployeeQuantityFieldsConfig(employeeQuanityFieldsConfig);
    }, []);

    return { employeeQuantityFieldsConfig };
};

export default useEmployeeQuantityFieldsConfig;
